/**
 * Homepage SEO (TZ-248). `index.html` must match these for first paint / crawlers without JS.
 */
export const SITE_TITLE = 'حجز تذاكر المباريات والحفلات في العراق | Ticket Zone';

export const SITE_DESCRIPTION =
  'أول منصة لحجز التذاكر الإلكترونية في العراق. توفر تكت زون حجز تذاكر الحفلات، المباريات، الورشات والفعاليات بسهولة وأمان وبكل ثقة مع دعم لوسائل الدفع المحلية';

/** Tab title for all non-home routes until a page sets its own via Helmet. */
export const SITE_TITLE_FALLBACK = 'Ticket Zone';

export const isHomePagePath = (pathname: string): boolean => pathname === '/';
